/**
 * Returns values from `array`. if element with same key exists in `second`, returns element from second instead
 */
export const pickIfExists = (array, second, key) => {
    return array === null || array === void 0 ? void 0 : array.map(it => (second === null || second === void 0 ? void 0 : second.find(sm => (sm === null || sm === void 0 ? void 0 : sm[key]) === (it === null || it === void 0 ? void 0 : it[key]))) || it);
};
//# sourceMappingURL=arrays.utils.js.map